export default "__VITE_ASSET__2f6c8bf3__"